import axios, { AxiosInstance } from "axios";

const http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_WEBADAPTER_URL,
    timeout: 10 * 1000,
});

export default http;
